import {Inject, Injectable} from '@angular/core';
import {CountedAndPaginated} from "../interface/response/counted-and-paginated";
import {CommissionMarginReport} from "../interface/commission-margin-report";
import {Observable, ReplaySubject, Subject} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {FilterService} from "./filter.service";
import {DOCUMENT} from "@angular/common";
import {first, take} from "rxjs/operators";
import {CommissionJob} from "../interface/commission-job";
import {Uuid} from "../interface/response/uuid";
import {ListResponse} from "../interface/response/list-response";
import {Dictionary} from "../interface/dictionary";

@Injectable({
  providedIn: 'root'
})
export class CommissionMarginReportService {

  public readonly marginListSubject: ReplaySubject<CountedAndPaginated<CommissionMarginReport>>  = new ReplaySubject<CountedAndPaginated<CommissionMarginReport>>(1);

  constructor(
    private httpClient: HttpClient,
    private filterService: FilterService,
    @Inject(DOCUMENT) private document: Document,
  ) { }

  public sendForm(formData: object, marginId?: number): Observable<any> {
    if (marginId) {
      return this.httpClient.put(`/rest/crm/commission-margin-report/${marginId}`, formData)
        .pipe(
          take(1)
        );
    } else {
      return this.httpClient.post('/rest/crm/commission-margin-report', formData)
        .pipe(
          take(1)
        );
    }
  }

  public loadList(page: number, pageSize: number, filters: object,  sort?: { sortBy?: string; sortOrder?: string}): void {
    this.httpClient.get(`/rest/crm/commission-margin-report?page=${page + 1}&pageSize=${pageSize}&sortBy=${sort.sortBy ?? ''}&sortOrder=${sort.sortOrder ?? ''}`
      + this.filterService.parseFilters(filters))
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<CommissionMarginReport>) => {
        this.marginListSubject.next(result);
      });
  }

  public generateMargin(formData: any): Observable<any> {
    const formDataFormatted = {...formData};
    formDataFormatted.billingMonth = formDataFormatted.billingMonth.format('YYYY-MM');
    return this.httpClient.post(`/rest/crm/generate-margin-report`, formDataFormatted)
      .pipe(first());
  }

  public deleteJob(uuid: string): Observable<any> {
    return this.httpClient.delete(`/rest/crm/generate-margin-report/${uuid}`)
      .pipe(first());
  }
  public downloadFile(jobId: string): void{
    this.document.location.href = `/rest/crm/generate-margin-report/${jobId}/downloadFile`;
  }
}
